<template>
  <smd-one-col-layout class="modal-contact-number">
    <span class="ns-icon-ico027 modal-contact-number__close-btn"
          @click="closeModal"/>
    <div class="smd-form__row m-t-5 justify-content-center">
      <text-string label-id="txt352" :props="{strings: [branch.branchName]}"/>
    </div>

    <div class="smd-form__col"
         v-for="(contact, index) in branch.mobilenumbers"
         :key="index">
      <div class="Hyperlink1 dodgerBlue text-center">{{ contact }}</div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';

  export default {
    name: "modal-contact-number",
    mixins: [CloseModalMixin],
    props: {
      branch: {type: Object},
    },
  }
</script>

<style lang="scss">
  .modal-contact-number {
    position: relative;
  }

  .modal-contact-number__close-btn {
    position: absolute;
    top: -5px;
    right: -10px;
  }
</style>